export const LEFT_MENU_WIDTH = 260;

export const STYLE_BUTTON = `py-6 px-8 text-[16px]`;
export const STYLE_SEARCH_BUTTON = `px-12 py-6 h-21`;
export const SPACE_BUTTON = `space-x-5`;
